import img_1101SG from './1101SG.png';
import img_1102SG from './1102SG.png';
import img_1103SG from './1103SG.png';
import img_1104SG from './1104SG.png';

export const stahlgelaender = [
    {product_img: img_1101SG, titel: 'Modell - 1101SG'},
    {product_img: img_1102SG, titel: 'Modell - 1102SG'},
    {product_img: img_1103SG, titel: 'Modell - 103SG'},
    {product_img: img_1104SG, titel: 'Modell - 1104SG'}
]